module.exports = __webpack_public_path__ + "img/desktop_about_img.d5fdf230.jpg";